/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Password_SavedInputs */

const cs_settings_profile_password_saved = /** @type {(inputs: Settings_Profile_Password_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heslo bylo změněno`)
};

const en_settings_profile_password_saved = /** @type {(inputs: Settings_Profile_Password_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password updated`)
};

/**
* | output |
* | --- |
* | "Password updated" |
*
* @param {Settings_Profile_Password_SavedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_password_saved = /** @type {((inputs?: Settings_Profile_Password_SavedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Password_SavedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_password_saved(inputs)
	return cs_settings_profile_password_saved(inputs)
});